import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { node } from 'prop-types';
import { useEnteredView } from '@fiverr-private/hooks';

import { getContext } from '@fiverr-private/fiverr_context';
import classes from './index.module.scss';

const IntroVideoAnimationWrapper = ({ content }) => {
    const { experience } = getContext();
    const observableRef = useRef(null);
    const [ isViewed, setIsViewed ] = useState(false);

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => setIsViewed(true)
    });

    return (
        <div className={classNames(classes.contentWrapper)}>
            <div className={classNames(
                {
                    [classes.circleCore]: !experience?.isBusiness,
                    [classes.circleShowAnimation]: isViewed
                }
            )} ref={observableRef}>
                <div className={classes.imgContainer}>
                    {content}
                </div>
            </div>
        </div>
    );
};

IntroVideoAnimationWrapper.propTypes = {
    content: node.isRequired
};

export default IntroVideoAnimationWrapper;
